import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let HovercardComp;

class Hovercard extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: HovercardComp };  
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/hovercard-comp" */
            "../../../components/javascript/zcat-components/hovercard-comp"
        ).then(function(res) {
            HovercardComp = res.HovercardComp;
        }));

        
;
    }
}

export {Hovercard};

